import { defineComponent as _defineComponent } from 'vue';
import { BLink, BProgress, BProgressBar } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { isRegisteredUser } from "@/api";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import { bytesToString } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuotaMeter',
    setup(__props) {
        const { config } = useConfig();
        const { currentUser, isAnonymous } = storeToRefs(useUserStore());
        const hasQuota = computed(() => {
            var _a, _b;
            const quotasEnabled = (_a = config.value.enable_quotas) !== null && _a !== void 0 ? _a : false;
            const quotaLimited = (_b = (isRegisteredUser(currentUser.value) && currentUser.value.quota !== "unlimited")) !== null && _b !== void 0 ? _b : false;
            return quotasEnabled && quotaLimited;
        });
        const quotaLimit = computed(() => { var _a; return (_a = (isRegisteredUser(currentUser.value) && currentUser.value.quota)) !== null && _a !== void 0 ? _a : null; });
        const totalUsageString = computed(() => {
            var _a, _b;
            const total = (_b = (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.total_disk_usage) !== null && _b !== void 0 ? _b : 0;
            return bytesToString(total, true);
        });
        const usage = computed(() => {
            var _a, _b, _c, _d;
            if (hasQuota.value) {
                return (_b = (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.quota_percent) !== null && _b !== void 0 ? _b : 0;
            }
            return (_d = (_c = currentUser.value) === null || _c === void 0 ? void 0 : _c.total_disk_usage) !== null && _d !== void 0 ? _d : 0;
        });
        const quotaLink = computed(() => (isAnonymous.value ? "/login/start" : "/storage"));
        const quotaTitle = computed(() => isAnonymous.value ? "Login to Access Storage Details" : "Storage and Usage Details");
        const variant = computed(() => {
            if (!hasQuota.value || usage.value < 80) {
                return "success";
            }
            else if (usage.value < 95) {
                return "warning";
            }
            return "danger";
        });
        return { __sfc: true, config, currentUser, isAnonymous, hasQuota, quotaLimit, totalUsageString, usage, quotaLink, quotaTitle, variant, BLink, BProgress, BProgressBar };
    }
});
